import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { RouterConfig } from "./navigation/RouterConfig";
import { RootState } from "./redux/store";
import account from "./services/accountService";
import { setBonakirNotifications, setUserData } from "./redux/member";

import {
  getMyMemberDetails,
  setMemberPushToken,
} from "./services/memberService";
import { setSystemHub } from "./redux/app";
import { startSignalRConnection } from "./services/signalR";
import { HOMEPAGE } from "./navigation/Constants";
import { getMoodsOption } from "./services/moodService";
import { setMoodData } from "./redux/mood";
import { GlobalModal } from "./components/GlobalModal";
import "./css/appCustom.css";
import { AppLanguages, HomeCarpetFilterCategory } from "./helpers/Enums";
import { sendMessageToWebViewWrapper } from "./helpers/Functions";
import NoInternetConnection from "./components/NoInternetConnection";

import { setWindowFunc } from "./services/native";
import { setHomeCarpetFilterCategory } from "./redux/carpet";
import FreezedAccount from "./components/FreezedAccount";
import BlockedAccount from "./components/BlockedAccount";
import NeedToVerifyProfile from "./components/NeedToVerifyProfile";

import OneSignal from "react-onesignal";

function App() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [isOneSignalInitialized, setIsOneSignalInitialized] = useState(false);
  const appSettings = useSelector((state: RootState) => state.app);
  const member = useSelector((state: RootState) => state.member);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  // useEffect(() => {
  //    if (!isOneSignalInitialized) {
  //       OneSignal.init({ appId: 'ef30a634-e027-455f-8f36-cbf5695c8650', serviceWorkerPath: "../public/assets/js/OneSignalSDKWorker.js" }).then(() => {
  //          setIsOneSignalInitialized(true);
  //          console.log("here in init onesignal")
  //          OneSignal.Slidedown.promptPush();

  //       }).catch(e => {
  //          console.log(e);
  //       })
  //    }

  // }, [])

  useEffect(() => {
    setWindowFunc();
    document.addEventListener("getPushToken", (e: any) =>
      onGetPushToken(e.detail.pushToken)
    );
  }, []);

  const onGetPushToken = async (pushToken: string) => {
    const { unique_name }: any = account.getCurrentUser();
    if (pushToken !== "no token" && unique_name) {
      await setMemberPushToken(unique_name, pushToken);
    }
  };

  useEffect(() => {
    if (location.pathname !== "/Home") {
      dispatch(
        setHomeCarpetFilterCategory({
          value: HomeCarpetFilterCategory.AVAILABLE_NOW,
          text: "כל החברים",
        })
      );
    }
  }, [location]);

  // useEffect(() => { was solution to check version of the react app
  //    isUpToDate();
  // }, []);

  // const isUpToDate = async () => {

  //    const { data } = await getCurrentReactVersion();
  //    if (!data) {
  //       window.location.reload();
  //    }

  // }

  useEffect(() => {
    sendMessageToWebViewWrapper({
      action: "urlChange",
      payload: {
        url: location.pathname + location.search,
      },
    });
  }, [location]);

  useEffect(() => {
    setIsLoading(true);
    getMemberData();
  }, [appSettings.completeRegistration, appSettings.loginComplete]);

  const getMemberData = async () => {
    const token = account.getJwt();
    if (token) {
      await getMoodData();
      const { unique_name }: any = account.getCurrentUser();
      const { data } = await getMyMemberDetails(unique_name);

      if ((window as any).pushToken) {
        await setMemberPushToken(unique_name, (window as any).pushToken);
      }
      // sendMessageToWebViewWrapper({
      //    action: "GetMemberCode",
      //    payload: {
      //       memberCode: unique_name
      //    }
      // });
      dispatch(setUserData(data));
      // dispatch(setOpenMoodSelectQuestions(data.shouldOpenSelectMood))
      dispatch(
        setSystemHub(startSignalRConnection(unique_name, history, dispatch))
      );
      //   dispatch(setNumberOfUnreadMessages(data.unreadMessageCount ?? 0));

      if (appSettings.loginComplete) history.replace(HOMEPAGE);
    }
    setIsLoading(false);
    // sendMessageToWebViewWrapper({
    //    action: "AppLoaded",
    // })
  };

  const getMoodData = async () => {
    const { data } = await getMoodsOption(AppLanguages.HEB);
    dispatch(setMoodData(data));
  };

  useEffect(() => {
    if (member.memberCode) {
      dispatch(setBonakirNotifications(member.memberCode));
    }
  }, [location]);

  useEffect(() => {
    //add accesability script for desktop and prevent it from flashing in mobile
    if (window.screen.width > 1380) {
      const script = document.createElement("script");
      script.src = "./include/accessibilityControl/accessibilityControl.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  // if (!appSettings.loginComplete && !appSettings.completeRegistration)
  //   if (isLoading) return <Splash />

  //TODO: For Debugging!
  useEffect(() => {
    console.log("App.tsx Member: ", member);
  }, [member]);

  return (
    <>
      {/* cache images */}
      <img
        src="/assets/images/broken_internet.svg"
        style={{ display: "none" }}
      />
      {/* cache images */}
      <NoInternetConnection>
        <BlockedAccount member={member}>
          <FreezedAccount member={member}>
            <NeedToVerifyProfile member={member}>
              <GlobalModal>
                <div className="disable_highlight">
                  {!isLoading && <RouterConfig />}
                </div>
              </GlobalModal>
            </NeedToVerifyProfile>
          </FreezedAccount>
        </BlockedAccount>
      </NoInternetConnection>
    </>
  );
}

export default App;
